import img1A from '../components/Media/0102carousel-notes.jpg';
import img1B from '../components/Media/0103carousel-working.jpg';
import img2A from '../components/Media/0201dco-wireframes.jpg';
import img2B from '../components/Media/0202dco-whiteboarding.jpg';
import img3A from '../components/Media/0301pac-stickies.jpg';
import img3B from '../components/Media/0302pac-collab.jpg';
import img4A from '../components/Media/0401storyboards.jpg';
import img4B from '../components/Media/0402on-location.jpg';
import img5A from '../components/Media/0501localteam-shirt.jpg';
import img5B from '../components/Media/0502localteam-hat.jpg';
import img6A from '../components/Media/0601icon.jpg';
import img6B from '../components/Media/0602map.png';
import img7A from '../components/Media/glab-details-square.png';
import img7B from '../components/Media/glab-metrics-square.png';

export default [
  {
    id: 1, 
    section: 'feed-ads',
    linkText: 'Feed Ads',
    items: [
      { id: 2, type: 'ProjectIntro', content: { title: 'Growing Facebook\'s most profitable ad', description: 'We worked to expand Carousel Ads from a simple product gallery to one of Facebook\'s most useful and versatile ad and post types for brands.', tags: [ 'UI DESIGN, ', 'USER RESEARCH, ', 'UX STRATEGY ' ] }},
      { id: 3, type: 'Media', content: { type: 'video', src: require('../components/Media/posterImgs/carousel-poster.jpg'), vidSrc: require('../components/Media/carouselVid.mov'), paddingTop: '55.55%' } },
      { id: 4, type: 'MediaSplit', content: { leftImg: img1A, rightImg: img1B } },
      { id: 5, type: 'ProjectIntro', content: { title: 'Building a new ad format from scratch', description: 'The knowledge we gained from our work on Carousel Ads directly translated into building a new creation tool for the yet unreleased Canvas Ads. We also had the opportunity to create a marketing site for the feature.', tags: [ 'UI DESIGN, ', 'USER RESEARCH, ', 'UX STRATEGY, ', 'DEVELOPMENT' ] } },
      { id: 6, type: 'Media', content: { type: 'video', src: require('../components/Media/posterImgs/canvas-builder-poster.jpg'), vidSrc: require('../components/Media/canvas-builder.mov'), paddingTop: '48.33%' }, contentGroup: 1 },
      { id: 7,
        type: 'Callout',
        content: {
          intro: 'The Feed Ads team are some of our oldest friends at Facebook. We\'ve shipped a lot together. Here\'s a shoutout to other projects we\'ve played a part in.',
          title1: 'BRANDED CONTENT',
          paragraph1: 'A lot of content from celebrities or public figures is sponsored by companies. We were tasked with designing a simple way for users to tag sponsors according to branded content guidelines.',
          title2: 'BOOST LIVE VIDEO',
          paragraph2: 'After the launch of live video, we worked with the Feed Ads team on ways to boost a live video before it\'s broadcasted so users could reach a larger audience and be encouraged to go live more often.' },
         },
    ],
  },
  {
    id: 8, 
    section: 'api',
    linkText: 'Ads API',
    items: [
      { id: 9, type: 'ProjectIntro', content: { title: 'Bringing the benefits of machine learning directly to advertisers', link: 'api', linkText: 'Ads API', linkContentGroup: 2, description: 'We led the design effort for the Dynamic Creative Optimization (DCO), an entirely new feature that allows advertisers to increase their overall ROI by automatically optimizing ads.', tags: [ 'UI DESIGN, ', 'USER RESEARCH, ', 'UX STRATEGY ' ] } },
      { id: 10, type: 'MediaSplit', content: { leftImg: img2A, rightImg: img2B } },
      { id: 11, type: 'Media', content: { type: 'video', src: require('../components/Media/posterImgs/dco-poster.jpg'), vidSrc: require('../components/Media/0301dco.mov'), paddingTop: '55.55%' } },
    ],
  },
  {
    id: 12,
    section: 'interfaces',
    linkText: 'Ads Interfaces',
    items: [
      { id: 13, type: 'ProjectIntro', content: { title: 'Adding affordances for quicker edits', link: 'interfaces', linkText: 'Ads Interfaces', linkContentGroup: 3, description: 'We redesigned the renaming experience in Power Editor to save users a considerable amount of time and offer up new features like auto-renaming for future objects.', tags: [ 'UI DESIGN, ', 'USER RESEARCH, ', 'UX STRATEGY ' ] } },
      { id: 14, type: 'Media', content: { type: 'video', src: require('../components/Media/posterImgs/renaming-poster.jpg'), vidSrc: require('../components/Media/0401renaming.mov'), paddingTop: '55.55%' } },
      { id: 15, type: 'ProjectIntro', content: { title: 'Reducing advertiser frustrations', link: '', description: 'We helped implement several UI changes to assist users in resolving errors in Power Editor by surfacing them better and making them both easily understood and actionable.', tags: [ 'UI DESIGN, ', 'USER RESEARCH, ', 'UX STRATEGY ' ] } },
      { id: 16, type: 'Media', content: { type: 'video', src: require('../components/Media/posterImgs/error-handling-poster.jpg'), vidSrc: require('../components/Media/error-handling.mov'), paddingTop: '55.55%' } },
      { id: 17,
        type: 'Callout',
        content: {
          intro: 'Some of the most impactful work came from improving existing experiences. We\'ve taken on several iterative Ads Interfaces projects with this goal in mind.',
          title1: 'PUBLISH IN PE',
          paragraph1: 'Adding the ability for Power Editor users to publish ads at the end of Create Flow has been an important step on the road to product convergence. These efforts resulted in a 1.5% increase in total Facebook revenue.',
          title2: 'SAVED STATE',
          paragraph2: 'If a user leaves the creation experience either intentionally or by accident (i.e. browser crashing), they would lose all of their progress. We worked to help create a saved state that allows advertisers to pick up exactly where they left off.' },
        },
    ],
  },
  {
    id: 18,
    section: 'learning', 
    linkText: 'Machine Learning',
    items: [
      { id: 19, type: 'ProjectIntro', content: { title: 'Creating a way for all teams to get their hands on machine learning tech', link: 'learning', linkText: 'Machine Learning', linkContentGroup: 4, description: 'We created a suite of tools that work together to allow all teams at Facebook to integrate complex tech into their products without being experts in AI or machine learning. ', tags: [ 'UI DESIGN, ', 'USER RESEARCH, ', 'UX STRATEGY ' ] } },
      { id: 20, type: 'Media', content: { type: 'img', src: require('../components/Media/wireframes.jpg'), paddingTop: '41.63%' } },
      { id: 21, type: 'Media', content: { type: 'video', src: require('../components/Media/posterImgs/bot-builder-poster.jpg'), vidSrc: require('../components/Media/bot-builder.mov'), paddingTop: '55.55%' } },
    ],
  },
  {
    id: 22,
    section: 'protect',
    linkText: 'Protect and Care',
    items: [
      { id: 23, type: 'ProjectIntro', content: { title: 'Simplifying the task of protecting users', link: 'protect', linkText: 'Protect and Care', linkContentGroup: 5, description: 'We facilitated a design sprint to identify issues with the current harassment claim routing process and define how it could be improved. We delivered a solution through design and user research.', tags: [ 'UI DESIGN, ', 'USER RESEARCH, ', 'UX STRATEGY ' ] } },
      { id: 24, type: 'MediaSplit', content: { leftImg: img3A, rightImg: img3B } },
      { id: 25, type: 'Media', content: { type: 'video', src: require('../components/Media/posterImgs/data-vis-poster.jpg'), vidSrc: require('../components/Media/data-vis.mov'), paddingTop: '48.33%' } },
    ],
  },
  {
    id: 30,
    section: '360',
    linkText: 'Facebook 360',
    items: [
      { id: 31, type: 'ProjectIntro', content: { title: 'Introducing the world to 360 video', linkContentGroup: 6, description: 'We leveraged the talents of our production team to take the process from start to finish in creating promotional videos for several new Facebook 360 features as part of their launch.', tags: [ 'STORYBOARDING, ', 'DIRECTION, ', 'FILM PRODUCTION, ', 'FILM EDITING' ] } },
      { id: 32, type: 'Media', content: { type: 'video', src: require('../components/Media/posterImgs/360-poster.jpg'), vidSrc: require('../components/Media/360-video.mov'), paddingTop: '56.52%' } },
      { id: 33, type: 'MediaSplit', content: { leftImg: img4A, rightImg: img4B } },
      { id: 34,
        type: 'Callout',
        content: {
          intro: 'We also had several other opportunities throughout the year to put our growing production team to work with various film and animation projects.',
          title1: 'SLIDESHOW LAUNCH',
          paragraph1: 'The Platform Marketing team reached out to us to create a video to accompany the launch of their Slideshow feature. We highlighted the key aspects of the feature then shot, edited and shipped within a tight two week timeframe.',
          title2: 'F8 DEMOS',
          paragraph2: 'Leading up to F8 2016, we worked with several teams to make UI demos for features launched that year. We used tools like Principle, Framer, Origami and After Effects to create eight demos that were shown throughout the venue.' }, },
    ],
  },
  {
    id: 35,
    section: 'local',
    linkText: 'Local Team',
    items: [
      { id: 36, type: 'ProjectIntro', content: { title: 'Unifying a team around a new identity', linkContentGroup: 7, description: 'Through several rounds of sketches, we developed a unique mark for the Local Team. Expanding the brand, we created swag that team members couldn\'t wait to get their hands on.', tags: [ 'VISUAL IDENTITY, ', 'BRAND GUIDELINES, ', 'COLLATERAL' ] } },
      { id: 37, type: 'Media', content: { type: 'video', src: require('../components/Media/posterImgs/sketches-poster.jpg'), vidSrc: require('../components/Media/sketches.mov'), paddingTop: '48.3%' } },
      { id: 38, type: 'MediaSplit', content: { leftImg: img5A, rightImg: img5B } },
    ],
  },
  {
    id: 39,
    section: 'social',
    linkText: 'Social Recs',
    items: [
      { id: 40, type: 'ProjectIntro', content: { title: 'Getting on board with recommendations', linkContentGroup: 8, description: 'We worked with Social Recs on creating a series of onboarding illustrations to lend a friendly and credible face to the feature, reassuring users that suggestions were coming from their friends, not companies.', tags: [ 'VISUAL IDENTITY, ', 'BRAND GUIDELINES, ', 'COLLATERAL ' ] } },
      { id: 41, type: 'Media', content: { type: 'img', src: require('../components/Media/sketches.jpg'), paddingTop: '48.3%' } },
      { id: 42, type: 'MediaSplit', content: { leftImg: img6A, rightImg: img6B } },
      { id: 43, type: 'Media', content: { type: 'img', src: require('../components/Media/map-creation-illustration.png'), paddingTop: '50.55%' } },
    ]
  },
  {
    id: 44,
    section: 'gestalt',
    linkText: 'Developing Internal Tools',
    items: [
      { id: 45, type: 'ProjectIntro', content: { title: 'Developing Internal Tools', linkContentGroup: 9, description: 'Our development team has been working with the Search Team at Facebook to improve the UI and UX of search tools: Gestalt, GLab, SRT.', tags: ['UI DESIGN, ', 'USER RESEARCH, ', 'UX STRATEGY, ', 'DEVELOPMENT']} },
      { id: 46, type: 'Media', content: { type: 'img', src: require('../components/Media/posterImgs/gestalt.png'), paddingTop: '48.3%' } },
      { id: 47, type: 'MediaSplit', content: { leftImg: img7A, rightImg: img7B } },
      { id: 48, type: 'Media', content: { type: 'img', src: require('../components/Media/glab-task-stream.png'), paddingTop: '50.55%' } },
    ]
  },
  {
    id: 9999,
    section: 'end-of-scrolling',
    linkText: null,
    items: []
  }
]



// WEBPACK FOOTER //
// ./src/store/index.js